import React from "react";
import PropTypes from "prop-types";
import RSButton from "reactstrap/lib/Button";
import Dropdown from "reactstrap/lib/Dropdown";
import DropdownToggle from "reactstrap/lib/DropdownToggle";
import DropdownMenu from "reactstrap/lib/DropdownMenu";
import DropdownItem from "reactstrap/lib/DropdownItem";

import { gatherClasses } from "../../lib/utils";
import Button from "../button/button";
import "./actionButtons.scss";

class ActionButtons extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
    // eslint-disable-next-line no-console
    console.warn(
      "[Deprecation] ActionButtons is deprecated from Orion. Use <Dropdown type='secondary' icon={{ classes:'di di-more' }} /> instead."
    );
  }

  getDropDown = items => {
    const { disableMoreBtn, allInMore, className, moreBtnSize, rightAligned } =
      this.props;
    const { isOpen } = this.state;
    const mainClass = gatherClasses(
      null,
      "oui-popup-action-buttons-wrapper",
      allInMore ? className : null
    );
    return (
      <Dropdown
        inNavbar
        isOpen={isOpen}
        toggle={this.toggle}
        className={mainClass}
      >
        <DropdownToggle tag="div" disabled={disableMoreBtn}>
          <RSButton
            disabled={disableMoreBtn}
            className="oui-popup-toggle-btn"
            color="primary"
            outline
            size={moreBtnSize}
            aria-label="show more"
          >
            <svg
              className="oui-more-icon-svg"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 12 48"
            >
              <circle cx="6" cy="6" r="6" />
              <circle cx="6" cy="24" r="6" />
              <circle cx="6" cy="42" r="6" />
            </svg>
          </RSButton>
        </DropdownToggle>
        <DropdownMenu right={rightAligned} className="popup-action-buttons">
          {items.map(item => {
            return (
              <DropdownItem
                className="popup-action-btn dropdown-item"
                key={item.label}
                onClick={item.onClick}
                disabled={item.disabled}
              >
                {item.label}
              </DropdownItem>
            );
          })}
        </DropdownMenu>
      </Dropdown>
    );
  };

  toggle = () => {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
  };

  render() {
    const { buttons, allInMore, dataTestId } = this.props;
    const nButtons = buttons.length;
    // No buttons provided
    if (!nButtons) return null;
    // If allInMore is true, put all the buttons inside more dropdown
    if (allInMore) {
      return this.getDropDown(buttons);
    }
    // Exactly 2 buttons provided
    if (nButtons <= 2) {
      return (
        <div className={gatherClasses(this.props, "action-btn-wpr")}>
          {buttons.map((button, index) => {
            return (
              <Button
                key={`${button.label}-${index}`}
                type={button.type}
                size={button.size}
                className={gatherClasses(
                  null,
                  button.className,
                  index !== buttons.length - 1 ? "mr-3" : null
                )}
                onClick={button.onClick}
                disabled={button.disabled}
                label={button.label}
              />
            );
          })}
        </div>
      );
    }
    // More than 2 buttons provided
    const firstButton = buttons[0];
    const firstButtonClasses = gatherClasses(
      null,
      "mr-3",
      firstButton.className
    );
    return (
      <div
        data-testid={dataTestId}
        className={gatherClasses(this.props, "action-btn-wpr")}
      >
        {/* First Button */}
        <Button
          type={firstButton.type}
          size={firstButton.size}
          className={firstButtonClasses}
          onClick={firstButton.onClick}
          disabled={firstButton.disabled}
          label={firstButton.label}
        />
        {/* Rest of the buttons inside more dropdown */}
        {this.getDropDown(buttons.slice(1))}
      </div>
    );
  }
}

ActionButtons.propTypes = {
  className: PropTypes.string,
  buttons: PropTypes.arrayOf(PropTypes.object).isRequired,
  allInMore: PropTypes.bool,
  rightAligned: PropTypes.bool,
  moreBtnSize: PropTypes.oneOf(["sm", "md", "lg"]),
  disableMoreBtn: PropTypes.bool,
  dataTestId: PropTypes.string
};

ActionButtons.defaultProps = {
  className: "",
  // eslint-disable-next-line react/default-props-match-prop-types
  buttons: [],
  allInMore: false,
  rightAligned: true,
  moreBtnSize: "md",
  disableMoreBtn: false,
  dataTestId: "orion-action-buttons"
};

ActionButtons.displayName = "OrionActionButtons";

export default ActionButtons;
